import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "Id7C0X",
    defaultMessage: "You are about to install {name}",
    description: "section header",
  },
  permissionsTitle: {
    id: "VsGcdP",
    defaultMessage: "App permissions",
    description: "section header",
  },
  permissionsInstallDescription: {
    id: "BL/Lbk",
    defaultMessage: "Installing this app will give it following permissions:",
    description: "install app permissions",
  },
  permissionsUninstallDescription: {
    id: "t1UYU6",
    defaultMessage:
      "Uninstalling the app will remove all your customer’s personal data stored by {name}. ",
    description: "install app privacy",
  },
  dataPrivacyLearnMore: {
    id: "k5lHFp",
    defaultMessage: "Learn more about data privacy",
    description: "app data privacy link",
  },
  installButton: {
    id: "PkCmGU",
    defaultMessage: "Install App",
    description: "install button",
  },
});
